var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":{ name: _vm.hasAdmin ? _vm.setActiveSection : 'main' }}},[_c('img',{staticClass:"logo-image is-main",attrs:{"alt":_vm.$saas.name,"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }